<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-back-button default-href="/today"></ion-back-button>
        </ion-buttons>
        <ion-title>Push-рассылка</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <div class="push-card">
        <ion-item>
          <ion-label position="stacked">Заголовок</ion-label>
          <ion-input v-model="title" maxlength="120" placeholder="Например: Важное уведомление"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="stacked">Сообщение</ion-label>
          <ion-textarea
            v-model="body"
            auto-grow
            maxlength="1000"
            placeholder="Текст сообщения для администраторов и менеджеров"
          ></ion-textarea>
        </ion-item>
        <ion-button expand="block" class="send-button" :disabled="sending || !canSend" @click="sendBroadcast">
          {{ sending ? 'Отправляем...' : 'Отправить push' }}
        </ion-button>
      </div>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonInput,
  IonItem,
  IonLabel,
  IonPage,
  IonTextarea,
  IonTitle,
  IonToolbar,
  toastController,
} from '@ionic/vue';
import { defineComponent } from 'vue';
import AdminService from '@/services/admin.service';

export default defineComponent({
  name: 'AdminPushBroadcast',
  components: {
    IonBackButton,
    IonButton,
    IonButtons,
    IonContent,
    IonHeader,
    IonInput,
    IonItem,
    IonLabel,
    IonPage,
    IonTextarea,
    IonTitle,
    IonToolbar,
  },
  data() {
    return {
      title: '',
      body: '',
      sending: false,
      adminService: new AdminService(),
    };
  },
  computed: {
    canSend(): boolean {
      return this.title.trim().length > 0 && this.body.trim().length > 0;
    },
  },
  methods: {
    async sendBroadcast() {
      if (!this.canSend || this.sending) return;
      this.sending = true;
      try {
        await this.adminService.sendAdminPushBroadcast({
          title: this.title.trim(),
          body: this.body.trim(),
        });
        this.title = '';
        this.body = '';
        await this.showToast('Рассылка отправлена');
      } catch {
        await this.showToast('Не удалось отправить рассылку');
      } finally {
        this.sending = false;
      }
    },
    async showToast(message: string) {
      const toast = await toastController.create({
        message,
        duration: 2200,
        position: 'top',
      });
      await toast.present();
    },
  },
});
</script>

<style scoped>
.push-card {
  max-width: 720px;
  margin: 0 auto;
}

.send-button {
  margin-top: 18px;
}
</style>
